export default "__VITE_ASSET__1yvr8_xS__"